/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Button, Spinner, Text } from "vr-react-components";

const EngineSelectionOverview = ({ width, height, onOpen }) => {
    const engines = useSelector((state) => state.user.engines);
    const canModify = useSelector((state) => state.private.device.canModify);

    const enginesInError = engines.status &&
        engines.selected.filter((x) => engines.status[x[0]] === "Unavailable");

    return (
        <a-entity>
            <Text
                text="Selected engines:"
                width={width / 2}
                sizeDecimal={15 / width}
                position={`${-width / 2 + width * 0.1} ${height * 0.1} 0`}
                baseline="bottom"
            />
            <a-entity position={`0 ${height * 0.1} 0`}>
                <Text
                    text={`${engines.selected.length}`}
                    width={width * 0.25}
                    sizeDecimal={10 / width}
                    position={`${width * 0.15} 0 0`}
                    baseline="bottom"
                />
                <Text
                    text={`/`}
                    width={width * 0.25}
                    sizeDecimal={16 / width}
                    position={`${width * 0.25} 0 0`}
                    baseline="bottom"
                />
                {engines.list.length > 0 ?
                    <Text
                        text={`${engines.list.length}`}
                        width={width * 0.25}
                        sizeDecimal={16 / width}
                        position={`${width * 0.3} 0 0`}
                        baseline="bottom"
                    /> : <Spinner radius={0.025} position="0.2 0.02 0" />
                }
            </a-entity>
            {engines.selected.length && enginesInError && enginesInError.length && (
                <a-entity
                    position={`${-width * 0.4 + height * 0.05} ${-height * 0.05} 0`}
                >
                    <a-image src="#Warning" height={height * 0.1} width={height * 0.1} />
                    <Text
                        text="Unavailable engines"
                        width={width * 0.8}
                        sizeDecimal={22 / width}
                        position={`${height * 0.1} 0 0`}
                        color="#f95454"
                    />
                </a-entity>
            )}
            <Button
                text={!engines.selected.length ? "Selection" : "See details"}
                width={width * 0.8}
                aframeClasses={canModify ? "collidable" : ""}
                height={height * 0.22}
                onClickHandler={onOpen}
                position={`0 ${-height * 0.3} 0.001`}
                textSizeDecimal={20 / width}
                type={Button.constants.primary}
                disabled={!engines.list.length}
            />
        </a-entity>
    );
}

export default EngineSelectionOverview;
